import { render } from "./Index.vue?vue&type=template&id=6d702a05"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=6d702a05&lang=scss&scope=true"
script.render = render

export default script